<template>
  <div>
    <span :class="customTextBoxStyle"
          v-html="parseTextFromContent(content)"
    ></span>
  </div>
</template>

<script>
import messageUtil from 'util/messages'
import Autolinker from 'autolinker'

export default {
  name: 'message_text',
  props: [
    'senderType', 'messageType', 'content', 'fontStyle'
  ],
  computed: {
    customTextBoxStyle () {
      if (this.senderType === 'USER') {
        return 'msgLink fs-14 message-content-wrap'
      } else {
        return 'msgLink ma-0 chat-bubble even fs-14 message-content message-content-wrap wc-white-bg'
      }
    }
  },
  methods: {
    parseTextFromContent (content) {
      const jsonContent = JSON.parse(content)
      const ProcessingText = this.messageType !== 'END' ? messageUtil.xssCheck(jsonContent.text) : messageUtil.xssCheck(jsonContent.text.split('<br>').join('\n'))

      if (jsonContent.code === undefined) {
        jsonContent.text = Autolinker.link(ProcessingText, {
          stripPrefix: false
        })
      }
      return jsonContent.text
    }
  }
}
</script>

<style>
  .msgLink a {
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/message_text.vue